import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';
import { productos } from '../../../idiomas/i18n/perfiles/catalogos/zh2';

@Injectable({
  providedIn: 'root'
})
export class AdicionalesService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusAdicionales(productoId: any){
    this.obtienInfo();
    let datos: any = {productoId,	adicionales: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusAdicionales(datos){
    this.obtienInfo();
    // let datos: any = {fechaCertificar: anio,	adicionales: 3};
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }
  DesbloquearPasoAdicionales(datos){
    this.obtienInfo();
    console.log(datos);
    // let datos: any = {fechaCertificar: anio,	adicionales: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  guardaStatusAdicionalesMedir(anio: any){
    let datos: any = {productoId: anio,	adicionales: 3};
    this.obtienInfo();
    console.log("entro a actualiar stat adic");
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  getIdiomas(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.idiomasGuardados + this.idEmpresa);
  }

  getIdiomasProd(fecha: backInter.getIdiomaFechas){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + this.idEmpresa, fecha);
  }

  guardaAdicional(adicional:backInter.nuevoAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaAdicional + this.idEmpresa, adicional);
  }

  actualizaAdicional(adicional:backInter.modificaAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizaAdicional + this.idEmpresa, adicional);
  }

  borraAdicional(adicional:backInter.modificaAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizaAdicional + this.idEmpresa, adicional);
  }

  getAllAdicionales(anio: number){
    this.obtienInfo();
    let datos: any = {fechaCertificar: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getAllAdicionales + this.idEmpresa, datos);
  }

  guardaOpcionRespuestaAdicional(opcion:backInter.nuevaOpcionAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaOpcionRespuestaAdicional + this.idEmpresa, opcion);
  }

  actualizaOpcionRespuestaAdicional(opcion:backInter.nuevaOpcionAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizaAdicional + this.idEmpresa, opcion);
  }

  eliminaOpcionRespuestaAdicional(opcion:backInter.nuevaOpcionAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizaAdicional + this.idEmpresa, opcion);
  }

  guardaTraduccionAdicional(traduccion:backInter.nuevoAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaTraduccionAdicional + this.idEmpresa, traduccion);
  }

  //SERVICIOS MEDIR
  getStatusAdicionalesMedir(anio: number){
    this.obtienInfo();
    let datos: any = {fechaMedir: anio,	adicionales: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }

  getAllAdicionalesMedir(anio: number){
    this.obtienInfo();
    let datos: any = {fechaMedir: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getAllAdicionales + this.idEmpresa, datos);
  }

  getIdiomasProdMedir(fecha: backInter.getIdiomaFechas){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getIdiomasGuardados + this.idEmpresa, fecha);
  }

  guardaAdicionalMedir(adicional:backInter.nuevoAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaAdicional + this.idEmpresa, adicional);
  }

  actualizaAdicionalMedir(adicional:backInter.modificaAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.actualizaAdicional + this.idEmpresa, adicional);
  }

  borraAdicionalMedir(adicional:backInter.modificaAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.actualizaAdicional + this.idEmpresa, adicional);
  }

  guardaOpcionRespuestaAdicionalMedir(opcion:backInter.nuevaOpcionAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaOpcionRespuestaAdicional + this.idEmpresa, opcion);
  }

  actualizaOpcionRespuestaAdicionalMedir(opcion:backInter.nuevaOpcionAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.actualizaAdicional + this.idEmpresa, opcion);
  }

  eliminaOpcionRespuestaAdicionalMedir(opcion:backInter.nuevaOpcionAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.actualizaAdicional + this.idEmpresa, opcion);
  }

  guardaTraduccionAdicionalMedir(traduccion:backInter.nuevoAdicional){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaTraduccionAdicional + this.idEmpresa, traduccion);
  }

//SERVICIOS FOCUS AREA
guardaStatusAdicionalesFocus(encuestaID: any){
  this.obtienInfo();
  let datos: any = {encuestaID,	adicionales: 3};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
}

desbloquearPasoAdicionalesFocus(encuestaID: any){
  this.obtienInfo();
  let datos: any = {encuestaID,	adicionales: 2};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
}

getStatusAdicionalesFocus(encuestaID: any){
  this.obtienInfo();
  let datos: any = {encuestaID,	adicionales: 1};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getStatusPart + this.idEmpresa, datos);
}

  guardaAdicionalesFocus(datos){

  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.addAdicionales + localStorage.getItem('encuestaID'),datos);
}
  actualizaAdicionalFocus(datos){
    console.log(datos);
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.updatePreguntaAdicionales + localStorage.getItem('encuestaID'),datos);
}
  getPreguntasAdicionalesFocus(){
    this.obtienInfo();
    let datos: any={empresaId:this.idEmpresa, seccion:7};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getPreguntasAdiocnales + localStorage.getItem('encuestaID'),datos);
}
   getListaIdiomasFocus(){
     this.obtienInfo();
  let datos :any={empresaId:this.idEmpresa}
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getListaIdiomasFocus + localStorage.getItem('encuestaID'),datos);//id plantilla fecha certif
   }

   guardaOpcionAdicionalFocus(datos){
     console.log(datos);
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.addOpcionTipoPregunta + localStorage.getItem('encuestaID'),datos);
   }
   actualizaOpcionAdicionalFocus(datos){
     console.log(datos);
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.updatePreguntaAdicionales + localStorage.getItem('encuestaID'),datos);
 }

   borrarPreguntaAdicionalFocus(datos){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.deletePreguntaFocus + localStorage.getItem('encuestaID'),datos);
   }
   borrarOpcionPreguntaAdicionalFocus(datos){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.deleteOpcionPreguntaFocus + localStorage.getItem('encuestaID'),datos);
   }
   getTraduccionesAdicionalFocus(datos){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getTraduccionesAdicionalesFocus+ localStorage.getItem('encuestaID'),datos);
   }
   guardaTraduccionAdicionalFocus(datos){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.saveTraduccionesAdicionalesFocus+ localStorage.getItem('encuestaID'),datos);
   }

   actualizaAdicionalTraduccionesFocus(datos){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.updatePreguntaAdicionalTraduccion+ localStorage.getItem('encuestaID'),datos);
   }
   guardaTraduccionOpcionesAdicionalFocus(datos){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.saveTraduccionesAdicionalesFocus+ localStorage.getItem('encuestaID'),datos);
   }

   getPreguntasAdicionalesFocusAdmin(data){
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getPreguntasAdiocnalesAdmin + localStorage.getItem('encuestaID'),data);
 }
 getTraduccionesAdicionalFocusAdmin(datos){
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getTraduccionesAdicionalesFocusAdmin+ localStorage.getItem('encuestaID'),datos);
 }


 actulizaBanderaEncuestaFocus(datos:any){
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.actualizaBanderaEncuesta+ localStorage.getItem('encuestaID'),datos);
}
 actulizaBanderaEncuestaFocusPrincipal(datos:any,idencuesta?:any){
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.actualizaBanderaEncuesta+ idencuesta,datos);
}

 getActulizaBanderaEncuestaFocus(datos:any){
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getActualizaBanderaEncuesta+ localStorage.getItem('encuestaID'),datos);
}

 actulizaValorOpcionRespuesta(datos:any){
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.updateValorOpcion+ localStorage.getItem('encuestaID')+"/"+ localStorage.getItem('companyID'),datos);
}
}
